"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

interface TextureCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const TextureCardStyled = React.forwardRef<HTMLDivElement, TextureCardProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "w-full overflow-hidden rounded-[20px] border border-neutral-300/50 bg-white shadow-sm dark:border-neutral-800/50 dark:bg-neutral-900",
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);
TextureCardStyled.displayName = "TextureCardStyled";

const TextureCardHeader = React.forwardRef<HTMLDivElement, TextureCardProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("px-6 py-4", className)} {...props}>
        {children}
      </div>
    );
  }
);
TextureCardHeader.displayName = "TextureCardHeader";

const TextureCardContent = React.forwardRef<HTMLDivElement, TextureCardProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("px-6 py-4", className)} {...props}>
        {children}
      </div>
    );
  }
);
TextureCardContent.displayName = "TextureCardContent";

const TextureCardFooter = React.forwardRef<HTMLDivElement, TextureCardProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("px-6 py-4", className)} {...props}>
        {children}
      </div>
    );
  }
);
TextureCardFooter.displayName = "TextureCardFooter";

const TextureCardTitle = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, children, ...props }, ref) => {
  return (
    <h3 ref={ref} className={cn("text-xl font-semibold", className)} {...props}>
      {children}
    </h3>
  );
});
TextureCardTitle.displayName = "TextureCardTitle";

const TextureSeparator = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "h-px w-full bg-neutral-200/60 dark:bg-neutral-700/60",
        className
      )}
      {...props}
    />
  );
});
TextureSeparator.displayName = "TextureSeparator";

export {
  TextureCardContent,
  TextureCardFooter,
  TextureCardHeader,
  TextureCardStyled,
  TextureCardTitle,
  TextureSeparator,
};
